import React from "react";
import { Link } from "react-router-dom";
import SocialLinks from "./SocialLinks";
import { trackMetaCustomEvent } from "../utils/metaPixel";

function PinIcon() {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M12 21s6-5.25 6-11a6 6 0 1 0-12 0c0 5.75 6 11 6 11Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            <circle cx="12" cy="10" r="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        </svg>
    );
}

function TagIcon() {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M4 11.2V5h6.2L20 14.8 14.8 20 4 11.2Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            <circle cx="8" cy="8" r="1.35" fill="currentColor" />
        </svg>
    );
}

function CrewIcon() {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <circle cx="12" cy="8" r="3" fill="none" stroke="currentColor" strokeWidth="1.8" />
            <path d="M6.5 20c.55-3.25 2.5-5 5.5-5s4.95 1.75 5.5 5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            <path d="M4.5 17.8c.32-1.8 1.38-2.9 3.12-3.25M19.5 17.8c-.32-1.8-1.38-2.9-3.12-3.25" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.75" />
        </svg>
    );
}

export default function HomeIntro() {
    const trackPassCta = () => {
        trackMetaCustomEvent("PassCTA", {
            location: "home_intro",
            destination: "passes",
            page_path: "/",
        });
    };

    return (
        <section className="home-intro home-intro-v2">
            <div className="intro-content home-intro-v2__card home-intro-v2__card--expanded">
                <div
                    className="home-intro-v2__mobile-social-top"
                    aria-label="Beach Bum Pass social and message links"
                >
                    <span className="home-intro-v2__mobile-social-label">
                        Follow &amp; message the crew
                    </span>

                    <SocialLinks
                        variant="intro-mobile-top"
                        className="home-intro-v2__mobile-social-links"
                        trackingLocation="home_intro_mobile_top"
                    />
                </div>

                <div className="home-intro-v2__top">
                    <div className="home-intro-v2__stamp" aria-hidden="true">
                        <span>Beach</span>
                        <strong>Bum</strong>
                        <span>Pass</span>
                    </div>

                    <div className="home-intro-v2__copy">
                        <div className="home-intro-v2__kicker">
                            Welcome to Beach Bum Pass
                        </div>

                        <p>
                            Prepaid access to Destin & Fort Walton Beach&apos;s top
                            adventures, attractions, and hidden gems. Just scan your
                            pass and walk right on the boat.
                        </p>
                    </div>

                    <div
                        className="home-intro-v2__perks"
                        aria-label="Beach Bum Pass highlights"
                    >
                        <div>
                            <span><PinIcon /></span>
                            <strong>Curated Local Experiences</strong>
                        </div>

                        <div>
                            <span><TagIcon /></span>
                            <strong>Exclusive Savings</strong>
                        </div>

                        <div>
                            <span><CrewIcon /></span>
                            <strong>Family & Group Friendly</strong>
                        </div>
                    </div>
                </div>

                <div className="home-intro-v2__social-panel">
                    <div className="home-intro-v2__social-copy">
                        <h3>Follow the Beach Bum crew!</h3>

                        <p>
                            Grab your pass and follow the crew.
                            New pass perks, adventures, and beach-day deals are always washing ashore.
                        </p>
                    </div>

                    <div
                        className="home-intro-v2__social-actions"
                        aria-label="Beach Bum Pass social links"
                    >
                        <Link
                            className="home-intro-v2__action primary"
                            to="/passes"
                            onClick={trackPassCta}
                        >
                            Get Your Pass
                        </Link>

                        <SocialLinks
                            variant="home-panel"
                            className="home-intro-v2__social-links"
                            trackingLocation="home_intro_social_panel"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
